import React from 'react'
import SupplyBillsFilterQuery from './fields/SupplyBillsFilterQuery'
import SupplyBillsFilterStatus from './fields/SupplyBillsFilterStatus'
import SupplyBillsFilterPaymentStatus from './fields/SupplyBillsFilterPaymentStatus'
import SupplyBillsFilterAgreeNachSupply from './fields/SupplyBillsFilterAgreeNachSupply'
import SupplyBillIsFilterAgreeEconomist from './fields/SupplyBillIsFilterAgreeEconomist'
import SupplyBillIsFilterAgreeDeputyDirectorSupply from './fields/SupplyBillIsFilterAgreeDeputyDirectorSupply'
import SupplyBillsFilterAgreeHeader from './fields/SupplyBillIsFilterAgreeHeader'

const SupplyBillsFilters = () => {
  return (
	<>
		<div className='myBlock__filtersOptions'>
			<SupplyBillsFilterQuery />
			<SupplyBillsFilterStatus />
			<SupplyBillsFilterPaymentStatus />
		</div>
		<div className='myBlock__filtersOptions'>
			<SupplyBillsFilterAgreeNachSupply />
			<SupplyBillIsFilterAgreeEconomist />
			<SupplyBillIsFilterAgreeDeputyDirectorSupply />
			<SupplyBillsFilterAgreeHeader />
		</div>
	</>
  )
}

export default SupplyBillsFilters